import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { DATABASE_NAME } from 'src/app/config/app.config';
import { LOCAL_DATABASE } from 'src/app/core/enums/storage/local-database.enum';
import { STORE_DATABASE } from 'src/app/core/enums/storage/store-database.enum';
import { IndexedDBRepository } from 'src/app/shared/interface/indexed-db-storage.model';
import { BookingSessionPort } from '../../domain/ports/booking-session.port';

@Injectable()
export class BookingSessionAdapter
  extends IndexedDBRepository<string>
  implements BookingSessionPort
{
  readonly dbName = DATABASE_NAME;
  readonly instanceName = STORE_DATABASE.session;
  private readonly sessionKey = LOCAL_DATABASE.bookingId;

  get(): Observable<string | null> {
    return this.getItem(this.sessionKey).pipe(map((item) => item ?? null));
  }

  save(bookingId: string): Observable<void> {
    return this.setItem(this.sessionKey, bookingId).pipe(map(() => undefined));
  }

  delete(): Observable<void> {
    return this.removeItem(this.sessionKey);
  }
}
